import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Per-device memory for the desktop rail (DS04): at 1280px and up it shows
 * its labels unless the person collapsed it to icons. A per-viewer
 * convenience, so browser storage is enough.
 */
interface NavState {
  collapsed: boolean;
  toggleCollapsed: () => void;
}

export const useNavStore = create<NavState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggleCollapsed: () => set((s) => ({ collapsed: !s.collapsed })),
    }),
    { name: 'unipostudio.nav' },
  ),
);
